import { studioMediaPath } from './studioMedia';

const STUDIO_GENDER_STAGE_VIDEO = studioMediaPath('studio-gender.mp4');

export const STUDIO_GENDER_ASSETS = [
	{
		value: 'woman',
		labelKey: 'woman',
		image: studioMediaPath('studio-woman.png'),
		video: studioMediaPath('studio-woman.mp4'),
		videoFallback: STUDIO_GENDER_STAGE_VIDEO,
		priority: true,
	},
	{
		value: 'trans',
		labelKey: 'trans',
		image: studioMediaPath('studio-trans.png'),
		video: studioMediaPath('studio-trans.mp4'),
		videoFallback: STUDIO_GENDER_STAGE_VIDEO,
	},
	{
		value: 'men',
		labelKey: 'men',
		image: studioMediaPath('studio-men.png'),
		video: studioMediaPath('studio-men.mp4'),
		videoFallback: STUDIO_GENDER_STAGE_VIDEO,
	},
];

export const STUDIO_GENDER_IMAGE_URLS = STUDIO_GENDER_ASSETS.flatMap(({ image, video }) =>
	[image, video].filter(Boolean),
);
